module.exports = __webpack_public_path__ + "static/media/logo-ca.d535fd74.svg";